import Schema from './dictionaries/en.json';

export type LocalizedDictionary = Record<keyof typeof Schema, string>;
export const localizedDictionaryKeys = Object.keys(Schema);
